import { FnGridAbstractCell } from '../../model/fn-grid-abstract-cell.model';
import { Component, ViewEncapsulation, OnInit } from '@angular/core';

@Component({
    selector: 'fn-grid-ratting',
    templateUrl: 'fn-grid-ratting.component.html',
    styleUrls: ['fn-grid-ratting.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class FnGridRattingComponent extends FnGridAbstractCell implements OnInit {
    rattingArray: Array<any> = [];

    override ngOnInit() {
        // tslint:disable-next-line: radix
        const rattingMaxLen = this.cellValue > 5 ? 5 : parseInt(this.cellValue);

        this.rattingArray = new Array(rattingMaxLen);
    }

    override blurAction() {
        this.isEditMode = false;
    }

    toggleInlineEdit() {
        this.isEditMode = !this.isEditMode;
    }
    blurRattingAction() {
        // tslint:disable-next-line: radix
        const rattingMaxLen = this.cellValue > 5 ? 5 : parseInt(this.cellValue);
        this.rattingArray = new Array(rattingMaxLen);
        this.blurAction();
    }
}
